import { Row } from "@/components/Row";
import { Text } from "@/components/Text";

export const ShopOutfitChanges = ({
  changes,
  isPositionDirty,
}: {
  changes: { key: string; label: string; price: number }[];
  isPositionDirty: boolean;
}) => {
  const total = changes.length + (isPositionDirty ? 1 : 0);

  /* Render */
  const render = () => {
    if (total === 0) {
      return (
        <Text className="font-mono text-[10px] font-black uppercase tracking-[0.1em] text-slate-500">
          Wearing your saved outfit
        </Text>
      );
    }

    return (
      <Row className="min-w-0 flex-wrap items-center gap-1.5">
        <Text className="mr-1 font-mono text-[10px] font-black uppercase tracking-[0.1em] text-slate-500">
          {total.toString()} change{total === 1 ? "" : "s"}
        </Text>
        {changes.map((change) => (
          <Row
            key={change.key}
            className="items-center gap-1 border-2 border-slate-900 bg-orange-100 px-1.5 font-mono text-[9px] font-black uppercase text-slate-900"
          >
            {change.label}
            {change.price > 0 ? (
              <Text className="border-l-2 border-slate-900 bg-amber-300 px-1 font-mono text-[9px] font-black text-slate-900">
                {change.price.toString()}
              </Text>
            ) : null}
          </Row>
        ))}
        {isPositionDirty ? (
          <Text className="border-2 border-slate-900 bg-orange-100 px-1.5 font-mono text-[9px] font-black uppercase text-slate-900">
            Position moved
          </Text>
        ) : null}
      </Row>
    );
  };

  return render();
};
